<template>
<main class="situation situation-detail">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ section_data ? sectionTitle(section_data.section_id) : '' }}</h1>

  <!-- Container -->
  <section class="container" v-show="isLoading">
    <div class="flex-center">
    
      <div class="row">
      <template v-if="lessonList && lessonList.length">
        <ul class="situation-list">
          <li class="box" v-for="(lesson, lesson_idx) in lessonList" :key="lesson_idx">
            <div class="title" v-html="lessonTitle(lesson)">
                <div class="situation-status" :class="lesson.status"></div>
            </div>
            <div class="situation-data-box">
            <template v-if="lesson.lesson_type=='lesson'">
              <div class="situation-data left">
                <div class="situation-progress">
                  <div class="progress-label">
                    <div class="label-correct">{{ $t('lesson.question.title') }} {{ $t('profile.correct_rate') }}</div>
                    <div class="correct-rate">{{ lesson.practice_rate  }}%</div>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-rate" :style="{ width: lesson.practice_rate + '%' }"></div>
                  </div>
                </div>
              </div>
              <div class="situation-data right">
                <div class="situation-progress">
                  <div class="progress-label">
                    <div class="label-correct">{{ $t('lesson.listening_practice.title') }} {{ $t('profile.correct_rate') }}</div>
                    <div class="correct-rate">{{ lesson.listening_rate  }}%</div>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-rate" :style="{ width: lesson.listening_rate + '%' }"></div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="lesson.lesson_type=='exam'">
              <div class="situation-data full">
                <div class="situation-progress">
                  <div class="progress-label">
                    <div class="label-correct">{{ $t('profile.correct_rate') }}</div>
                    <div class="correct-rate">{{ lesson.exam_rate }}%</div>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-rate" :style="{ width: lesson.exam_rate + '%' }"></div>
                  </div>
                </div>
              </div>
            </template>
            </div>
            <div class="row">
              <button type="button" class="button button-default next" :class="(lesson.status=='incomplete' && lesson.lesson_type!='exam') ? 'disabled' : ''" @click="selectLessonItem(lesson)">{{ $t('profile.to_lesson') }}</button>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading"></div>
      </template>
      </div>
    </div>
  </section>
</main>
</template>

<script>
  import {api} from "../../config";
  import status from '../../mixins/status';
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    mixins: [
      status
    ],
    props: {
      category: {
        type: String,
        required: true
      },
      level: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        section_data: {},
        lesson_list: [],
        learning_total: {},
        section_all: []
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      lessonList() {
         return this.lesson_list
      },
    },
    
    created() {
      const self = this
      
      self.loading = false
      
      self.$store.dispatch('showLoading', true)
      
      self.learning_total = self.$store.getters.learning_total
      
      
      axios.get(api.section + '?level=' + this.level.toLowerCase())
      .then(function(resp) {
        self.section_all = resp.data.section;
        
        self.section_data = self.section_all[self.category];

        axios.get(api.lessons, {
          params: {
            section_id: self.section_data.section_id,
            section_status: 'all'
          }
        })
        .then((resp) => {
          const lessons = resp.data
          
          for(let lessonData of lessons) {
            let lesson_data = lessonData;
            
            
            let questionLog = self.learning_total.question.filter(item => {
                return (item.lesson_id == lessonData.lesson_id)
            })
            
            
            if(lessonData.lesson_type == 'lesson') {
              // practice and listening
              
              let count_data = { practice: { correct_count: 0, answer_count: 0 },
                                listening : { correct_count: 0, answer_count: 0 } }

              
              for(let questionData of questionLog) {
                if(questionData.question_type == '31') {
                  count_data.practice.correct_count += questionData.correct_count;
                  count_data.practice.answer_count += questionData.answer_count;
                } else if(questionData.question_type == '32') {
                  count_data.listening.correct_count += questionData.correct_count;
                  count_data.listening.answer_count += questionData.answer_count;
                }
              }
              
              let practice_rate = 0;
              let listening_rate = 0;
              if(count_data.practice.correct_count && count_data.practice.answer_count) {
                practice_rate = Math.round((count_data.practice.correct_count / count_data.practice.answer_count) * 100);
              }
              if(count_data.listening.correct_count && count_data.listening.answer_count) {
                listening_rate = Math.round((count_data.listening.correct_count / count_data.listening.answer_count) * 100);
              }
              
              self.lesson_list.push({
                ...lessonData,
                practice_rate: practice_rate,
                listening_rate: listening_rate
              });
              
            } else if(lessonData.lesson_type == 'exam') {
              // exam
              let count_data = { exam: { correct_count: 0, answer_count: 0 } }

              
              for(let questionData of questionLog) {
                count_data.exam.correct_count += questionData.correct_count;
                count_data.exam.answer_count += questionData.answer_count;
              }
              
              let exam_rate = 0;
              if(count_data.exam.correct_count && count_data.exam.answer_count) {
                exam_rate = Math.round((count_data.exam.correct_count / count_data.exam.answer_count) * 100);
              }
              
              self.lesson_list.push({
                ...lessonData,
                exam_rate: exam_rate
              });
            }
          }
          self.$store.dispatch('showLoading', false)
          self.loading = true
        
        })
        .catch(err => {
          self.$store.dispatch("showLoading", false);
          self.loading = true
        });
        
        
      }).catch(err => {
        self.$store.dispatch("showLoading", false);
        self.loading = true
      });
    },

    mounted() {
      
      const self = this
      
      self.loading = true
    },
    methods: {
      sectionTitle(section_id) {
        let sessionName = 'Session'
        if(section_id == 1) {
          sessionName = sessionName + ' 1-10'
        } else if(section_id == 2) {
          sessionName = sessionName + ' 11-20'
        } else if(section_id == 3) {
          sessionName = sessionName + ' 21-30'
        } else if(section_id == 4) {
          sessionName = sessionName + ' 31-40'
        } else if(section_id == 5) {
          sessionName = sessionName + ' 41-50'
        } else if(section_id == 6) {
          sessionName = sessionName + ' 51-60'
        } else if(section_id == 7) {
          sessionName = sessionName + ' 61-70'
        } else if(section_id == 8) {
          sessionName = sessionName + ' 71-80'
        } else if(section_id == 9) {
          sessionName = sessionName + ' 81-90'
        }
        return sessionName
      },
      lessonTitle(lesson) {
        if(lesson.lesson_number) {
          return lesson.lesson_number + '. ' + lesson.sub_title
        } else {
          return lesson.sub_title
        }
      },
      
      selectLessonItem(row) {
        // Locked lessons cannot be viewed
        if ((row.lesson_type != "exam" && row.status == 'incomplete') || (row.lesson_type == "exam" && row.section_status == '0')) {
          return;
        }

        this.$store.dispatch('showLoading', true);
        this.$store.dispatch('setLessonData', row);
        this.$store.dispatch("setLessonStatus", row.status);

        // Update status the first time
        if (this.$store.getters.lesson_status == 'ready') {
          this.statusLesson('start');
        }

        // Get the contents of a Session or Exam
        let lessonData = this.$store.getters.lesson_data
        axios.get(api.contents, {
          params: {
            section_id: this.$store.getters.section_data.section_id,
            lesson_id: this.$store.getters.lesson_data.lesson_id,
            lesson_type: this.$store.getters.lesson_data.lesson_type
          }
        })
        .then((resp) => {
          this.$store.dispatch('setLessonContent',  resp.data)
          this.$store.dispatch('showLoading', false)

          let push_val = {name: 'lesson.introduction', params: { lesson_id: lessonData.lesson_id }}
          if (lessonData.lesson_type == 'exam') {
            push_val = {name: 'lesson.explanation', params: { lesson_id: lessonData.lesson_id, step: 'exam' }}
          }
          this.$router.push(push_val)
        })
        .catch(err => {
          this.$store.dispatch("showLoading", false);
        });
      },
      back() {
        this.$router.push({name: 'profile.situation.level', params: { level: this.level }})
      }
    },

  }
</script>
